import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useI18n } from "@/context/I18nContext";
import { countryName } from "@/components/GeoFilters";

const OTHER = "__other__";
const ALL = "__all__";

// Même liste que les lieux de stockage / événements des affiches, + « Autre, préciser »
export const DeliveryPlacePicker = ({ value, onChange, suggested = "", testid = "delivery-place", placeholder = "Choisir le lieu de livraison", autoOwn = false, rangeKey = "" }) => {
  const { t } = useI18n();
  const [loaded, setLoaded] = useState([]);
  const [other, setOther] = useState(false);
  const [country, setCountry] = useState(ALL);
  useEffect(() => {
    api.get("/events", { params: rangeKey ? { range_key: rangeKey } : {} }).then(({ data }) => setLoaded((data || []).map((p) => (p.kind === "stock"
      ? { ...p, name: p.company ? `${t("Chez")} ${p.company} (${p.city})` : p.city || p.name.replace(/^En stock à\s*/i, "") } : p)))).catch(() => {});
  }, [t, rangeKey]);
  useEffect(() => {
    const own = autoOwn && !value && loaded.find((p) => p.kind === "stock" && p.own);
    if (own) onChange(own.name);
  }, [autoOwn, loaded]); // eslint-disable-line react-hooks/exhaustive-deps
  const places = (suggested && !loaded.some((p) => p.name === suggested)
    ? [...loaded, { id: "suggested", name: suggested, kind: "stock" }] : loaded)
    .map((p, i) => ({ ...p, _i: i })).sort((a, b) => (a.kind === "stock" && b.kind === "stock" ? a.name.localeCompare(b.name, "fr", { sensitivity: "base" }) : a._i - b._i));
  const known = places.some((p) => p.name === value);
  const countries = [...new Set(places.map((p) => p.country).filter(Boolean))].sort((a, b) => countryName(a).localeCompare(countryName(b), "fr"));
  const shown = places.filter((p) => p.kind !== "stock" || country === ALL || p.country === country || p.name === value);
  const choice = other || (value && !known && places.length) ? OTHER : (known ? value : "");
  return (
    <div>
      {countries.length > 1 && (
        <Select value={country} onValueChange={setCountry}>
          <SelectTrigger className="h-8 text-xs mt-1" data-testid={`${testid}-country`}><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL}>{t("Tous les pays")}</SelectItem>
            {countries.map((c) => <SelectItem key={c} value={c} data-testid={`${testid}-country-${c}`}>{countryName(c)}</SelectItem>)}
          </SelectContent>
        </Select>
      )}
      <Select value={choice} onValueChange={(v) => { if (v === OTHER) { setOther(true); onChange(""); } else { setOther(false); onChange(v); } }}>
        <SelectTrigger className={`h-8 text-sm mt-1 ${value ? "" : "border-destructive/60"}`} data-testid={testid}><SelectValue placeholder={t(placeholder)} /></SelectTrigger>
        <SelectContent>
          {[["event", "Événements"], ["stock", "Lieux de stockage"]].map(([k, lbl]) => shown.some((p) => p.kind === k) && (
            <SelectGroup key={k}>
              <SelectLabel>{t(lbl)}</SelectLabel>
              {shown.filter((p) => p.kind === k).map((p) => <SelectItem key={p.id} value={p.name}>{p.name}</SelectItem>)}
            </SelectGroup>
          ))}
          <SelectItem value={OTHER} data-testid={`${testid}-other`}>{t("Autre, préciser")}</SelectItem>
        </SelectContent>
      </Select>
      {choice === OTHER && (
        <Input value={value} onChange={(e) => onChange(e.target.value)} placeholder={t("Préciser le lieu")} autoFocus
          data-testid={`${testid}-input`} className="h-8 text-sm mt-1" />
      )}
    </div>
  );
};
